// Virtual Try-On Styles Configuration
// Now uses AILabTools API - styles loaded dynamically from API
// These are fallback/default styles if API is unavailable

const BASE_URL = '/styles/try-on';

// Haircut Styles (Default/Fallback - API provides actual styles)
export const HAIRCUT_STYLES = [
  {
    styleId: 'bob-cut-001', // AILabTools style ID
    name: 'Bob Cut',
    thumbnailUrl: `${BASE_URL}/haircut/bob-cut-thumb.jpg`,
    category: 'haircut',
    description: 'Classic bob cut with side part',
    price: null,
    apiStyleId: 'bob-cut-001' // AILabTools API style ID
  },
  {
    styleId: 'pixie-cut-002',
    name: 'Pixie Cut',
    thumbnailUrl: `${BASE_URL}/haircut/pixie-cut-thumb.jpg`,
    category: 'haircut',
    description: 'Short and edgy pixie cut',
    price: null,
    apiStyleId: 'pixie-cut-002'
  },
  {
    styleId: 'long-layers-003',
    name: 'Long Layers',
    thumbnailUrl: `${BASE_URL}/haircut/long-layers-thumb.jpg`,
    category: 'haircut',
    description: 'Layered long hair with movement',
    price: null,
    apiStyleId: 'long-layers-003'
  },
  {
    styleId: 'short-bob-004',
    name: 'Short Bob',
    thumbnailUrl: `${BASE_URL}/haircut/short-bob-thumb.jpg`,
    category: 'haircut',
    description: 'Chin-length bob with texture',
    price: null,
    apiStyleId: 'short-bob-004'
  },
  {
    styleId: 'wavy-bob-005',
    name: 'Wavy Bob',
    thumbnailUrl: `${BASE_URL}/haircut/wavy-bob-thumb.jpg`,
    category: 'haircut',
    description: 'Bob with natural waves',
    price: null,
    apiStyleId: 'wavy-bob-005'
  },
  {
    styleId: 'curly-bob-006',
    name: 'Curly Bob',
    thumbnailUrl: `${BASE_URL}/haircut/curly-bob-thumb.jpg`,
    category: 'haircut',
    description: 'Bob cut with defined curls',
    price: null,
    apiStyleId: 'curly-bob-006'
  }
];

// Makeup Styles (Default/Fallback - API provides actual styles)
export const MAKEUP_STYLES = [
  {
    styleId: 'natural-001',
    name: 'Natural Look',
    thumbnailUrl: `${BASE_URL}/makeup/natural-thumb.jpg`,
    category: 'makeup',
    description: 'Natural everyday makeup',
    price: null,
    apiStyleId: 'natural-001'
  },
  {
    styleId: 'glam-002',
    name: 'Glam Look',
    thumbnailUrl: `${BASE_URL}/makeup/glam-thumb.jpg`,
    category: 'makeup',
    description: 'Glamorous evening look',
    price: null,
    apiStyleId: 'glam-002'
  },
  {
    styleId: 'smoky-eye-003',
    name: 'Smoky Eye',
    thumbnailUrl: `${BASE_URL}/makeup/smoky-eye-thumb.jpg`,
    category: 'makeup',
    description: 'Dramatic smoky eye look',
    price: null,
    apiStyleId: 'smoky-eye-003'
  },
  {
    styleId: 'bold-lips-004',
    name: 'Bold Lips',
    thumbnailUrl: `${BASE_URL}/makeup/bold-lips-thumb.jpg`,
    category: 'makeup',
    description: 'Bold lip color with natural eyes',
    price: null,
    apiStyleId: 'bold-lips-004'
  },
  {
    styleId: 'bridal-005',
    name: 'Bridal Makeup',
    thumbnailUrl: `${BASE_URL}/makeup/bridal-thumb.jpg`,
    category: 'makeup',
    description: 'Elegant bridal makeup',
    price: null,
    apiStyleId: 'bridal-005'
  },
  {
    styleId: 'party-006',
    name: 'Party Makeup',
    thumbnailUrl: `${BASE_URL}/makeup/party-thumb.jpg`,
    category: 'makeup',
    description: 'Fun party makeup look',
    price: null,
    apiStyleId: 'party-006'
  }
];

// Helper function to get styles by category
export const getStylesForCategory = (category) => {
  const normalizedCategory = category?.toLowerCase();
  
  if (normalizedCategory === 'haircut' || normalizedCategory === 'hair') {
    return HAIRCUT_STYLES;
  } else if (normalizedCategory === 'makeup' || normalizedCategory === 'make-up') {
    return MAKEUP_STYLES;
  }
  
  // Default: return both if category not recognized
  return [...HAIRCUT_STYLES, ...MAKEUP_STYLES];
};

// Get all styles
export const getAllStyles = () => {
  return [...HAIRCUT_STYLES, ...MAKEUP_STYLES];
};

// Get style by ID
export const getStyleById = (styleId) => {
  const allStyles = getAllStyles();
  return allStyles.find(style => style.styleId === styleId);
};

export default {
  HAIRCUT_STYLES,
  MAKEUP_STYLES,
  getStylesForCategory,
  getAllStyles,
  getStyleById
};
